module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "el-card"
  }, [(_vm.$slots.header || _vm.header) ? _c('div', {
    staticClass: "el-card-header"
  }, [_vm._t("header", [_vm._v(_vm._s(_vm.header))])], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "el-card-body",
    style: (_vm.bodyStyle)
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e1203b5a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/card/src/card.vue
// module id = 681
// module chunks = 0